appSocial.service('SocialThemeService', [
    function () {
        class SocialThemeService {
            constructor() {
                this.themeStyles = {};
            }

            setThemeStyles() {
                this.themeStyles = window.getComputedStyle(document.getElementsByTagName('body')[0]);
            }

            getThemeColor(component, variable) {
                /// --variable-component-guide-popup-closed-positions-path
                return this.themeStyles.getPropertyValue('--' + component + '-' + variable);
            }

            getThemeVariable(component, variable) {
                /// --variable-component-guide-popup-closed-positions-path
                return this.themeStyles.getPropertyValue('--variable-component-' + component + '-' + variable);
            }
        }

        return new SocialThemeService()
    }
])
